import React, { useEffect, useRef, useState } from 'react';
// import { connect, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import protectedRoute from '../../components/protectedRoute';
import Input from '../../components/Input/Input';
import messages from './messages';
import Button from '../../components/Button/Button';
import { black, green, red, orange } from '../../utils/style/colors';
import { apis, setBaseUrl } from './apis';
import Recaptcha from 'react-google-recaptcha';
import Select from '../../components/Select';
import cloneDeep from 'lodash/cloneDeep';
import Collapsible from '../../components/Collapsible/Collapsible';
import { AxiosResponse } from 'axios';
// import { appDispatch } from 'store/store';
// import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  CompanyAdvanceAdminRole,
  SupportRole,
} from 'store/companies/companiesUtils';
import {
  ICompany,
  // ICompanyMember,
  ICompanyRole,
  ICompanyRoleServer,
  ICompanyTemplate,
  IInvitedMember,
  IProject,
  IProjectStore,
  // IUserRoleView,
} from 'store/companies/companiesTypes';
// import {
//   addCompanyRole,
//   addCompanyRoleFn,
//   addMemberToCompany,
//   addMemberToCompanyFn,
//   addUserRoles,
//   addUserRolesFn,
// } from 'store/companies/companiesSlice';
import { IProvider } from 'store/providers/providerTypes';
import { ITwoFactorAuthenticationParams, IUser } from 'store/users/usersType';
import { IMultipleChoiceQuestionView } from 'store/survey/surveyTypes';
import { IAssignmentView, ITask } from 'store/tasks/tasksType';
// import { addRole } from '../../api/ManApi';
// import { appDispatch } from '../../store/store';

// type IStateToProps = {
//   thisUser: IThisUserState;
//   state: RootState;
// };

// type IDispatchToProps = {
//   addMember: (
//     member: ICompanyMember
//   ) => ReturnType<typeof addMemberToCompanyFn>;
//   addRole: (role: ICompanyRoleServer) => ReturnType<typeof addCompanyRoleFn>;
//   addRoles: (
//     userRoles: IUserRoleView[],
//     companyId: number
//   ) => ReturnType<typeof addUserRolesFn>;
// };

type OwnProps = RouteComponentProps;
const AnyRecaptcha: any = Recaptcha; // TODO send PR for style prop

type ComponentProps = OwnProps /*& IStateToProps & IDispatchToProps*/;
let logVar = '';

const mainServerUrl = 'https://app.rastech.ir';
const adminCompanyId = 11;
const adminProviderId = 2;
const setupProjectId = 1260;
const programTemplateId = 46142;
const stepTemplateId = 46143;
const setupProjectName = 'برنامه عملیاتی استقرار';
const baseCompanyId = 290;
let mainServerToken = '';
const NewHospital: React.FC<ComponentProps> = () => {
  // useEffect(() => {
  //   if (!thisUser.permissions?.includes('Edit_User')) redirectTo('/homepage');
  // }, []);

  const [baseCompany, setBaseCompany] = useState(
    undefined as ICompany | undefined
  );
  const init = async () => {
    while (!mainServerToken) {
      const user = prompt('main server user:') || '';
      const pass = prompt('main server pass:') || '';
      try {
        mainServerToken = (
          await apis.authenticate2FA(
            user.startsWith('0') ? user : null,
            user.startsWith('0') ? null : user,
            pass,
            true,
            false
          )
        ).data?.authInfo?.accessToken;
      } catch (e) {
        console.log('catched');
        console.log(e);
        /*do nothing*/
      }
      if (mainServerToken) {
        alert(`login successfull : ${mainServerToken}`);
        break;
      }
      alert('invalif login. try again');
    }
    // mainServerToken = prompt('main server token:') || '';
    apis
      .getCompany(mainServerToken!, baseCompanyId, false, false, false, false)
      .then((cr) => {
        setBaseCompany(cr.data);
      });
  };
  useEffect(() => {
    setBaseUrl(mainServerUrl);
    init();
  }, []);

  // const templates =
  //   baseCompany?.templates.map((it) => ({
  //     label: it.task!.taskName,
  //     value: it.taskId,
  //   })) || [];

  const [hospitalName, setHospitalName] = useState('');
  const [emailName, setEmailName] = useState('');
  const [nemayandehEmailName, setNemayandehEmailName] = useState('');
  const [nemayandehPassword, setNemayandehPassword] = useState('');
  const [domain, setDomain] = useState('');
  const [targetAdminToken, setTargetAdminToken] = useState('');
  // const [mainServerToken, setMainServerToken] = useState('');
  const [password, setPassword] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [log, setLog] = useState('');
  const reCaptcha: any = useRef();

  function getFinalName() {
    if (hospitalName.startsWith('مرکز')) return hospitalName.trim();
    return 'بیمارستان ' + hospitalName.trim();
  }

  const colorMap = {
    info: black,
    error: red,
    warn: orange,
    success: green,
    header: black,
  };
  const addLog = (
    s: string,
    type: 'header' | 'info' | 'error' | 'warn' | 'success'
  ) => {
    const tagName = type === 'header' ? 'h5' : 'li';
    logVar =
      logVar + `<${tagName} style="color: ${colorMap[type]}">${s}</${tagName}>`;
    setLog(logVar);
    if (type === 'error') throw 'error';
    return true;
  };
  useEffect(() => {
    const div = document.getElementById('logout');
    if (div) div.scrollTop = div.scrollHeight;
  }, [log]);

  const [projectRoleNames, setProjectRoleNames] = useState([
    'عضو اصلی',
    'رئیس کمیته',
    'دبیر کمیته',
    'مسئول کمیته‌ها',
    'دبیر اجرایی',
    'جانشین تام الاختیار',
    'دبیر علمی',
  ] as string[]);
  const [balinNames, setBalinNames] = useState([] as string[]);
  const [balinRoleNamesCombined, setBalinRoleNamesCombined] = useState(
    [] as string[]
  );
  const [balinRoleNamesCombinedUnique, setBalinRoleNamesCombinedUnique] =
    useState(['سرپرستار', 'رئیس بخش'] as string[]);
  const [balinRoleNamesUnique, setBalinRoleNamesUnique] = useState(
    [] as string[]
  );
  const [balinRoleNamesOther, setBalinRoleNamesOther] = useState(
    [] as string[]
  );
  const [paraclinicNames, setParaclinicNames] = useState([] as string[]);
  const [paraclinicRoleNamesOther, setParaclinicRoleNamesOther] = useState(
    [] as string[]
  );
  const [paraclinicRoleNamesUnique, setParaclinicRoleNamesUnique] = useState(
    [] as string[]
  );
  const [
    paraclinicRoleNamesCombinedUnique,
    setParaclinicRoleNamesCombinedUnique,
  ] = useState(['مسئول بخش'] as string[]);
  const [paraclinicRoleNamesCombined, setParaclinicRoleNamesCombined] =
    useState([] as string[]);
  const [officeNames, setOfficeNames] = useState([] as string[]);
  const [officeRoleNamesOther, setOfficeRoleNamesOther] = useState(
    [] as string[]
  );
  const [officeRoleNamesUnique, setOfficeRoleNamesUnique] = useState(
    [] as string[]
  );
  const [officeRoleNamesCombinedUnique, setOfficeRoleNamesCombinedUnique] =
    useState(['مسئول واحد'] as string[]);
  const [officeRoleNamesCombined, setOfficeRoleNamesCombined] = useState(
    [] as string[]
  );
  const [clinicNames, setClinicNames] = useState([] as string[]);
  const [clinicRoleNamesOther, setClinicRoleNamesOther] = useState(
    [] as string[]
  );
  const [clinicRoleNamesUnique, setClinicRoleNamesUnique] = useState(
    [] as string[]
  );
  const [clinicRoleNamesCombinedUnique, setClinicRoleNamesCombinedUnique] =
    useState(['مسئول'] as string[]);
  const [clinicRoleNamesCombined, setClinicRoleNamesCombined] = useState(
    [] as string[]
  );
  // const [toCopyTemplates, setToCopyTemplates] = useState([] as IOption[]);
  const [testMode, setTestMode] = useState(false);
  const [skipCopyTemplate, setSkipCopyTemplate] = useState(false);
  const [nemyandehOnly, setNemyandehOnly] = useState(false);
  const [onlyAddTask, setOnlyAddTask] = useState(false);
  let usePhone = false;
  const verifyInput = () => {
    if (
      hospitalName.trim().length < 1 ||
      (!nemyandehOnly && domain.trim().length < 1) ||
      (!nemyandehOnly && emailName.trim().length < 1) ||
      (!nemyandehOnly && password.trim().length < 1) ||
      (!testMode && nemayandehEmailName.trim().length < 1) ||
      (!testMode && nemayandehPassword.trim().length < 1)
    )
      addLog(messages.emptyInput, 'error');
    if (
      !nemyandehOnly &&
      !(/[a-z]*/.test(emailName) || /[0-9]*/.test(emailName))
    )
      addLog(messages.invalidEmailName, 'error');
    usePhone = /^[0-9]+$/.test(emailName);
    if (!testMode && !/[a-z]*/.test(nemayandehEmailName))
      addLog(messages.invalidEmailName, 'error');
    if (!usePhone && !/[a-zA-Z0-9\\~!@#$%^&*]*/.test(password))
      addLog(messages.invalidPassword, 'error');
    if (!testMode && !/[a-zA-Z0-9\\~!@#$%^&*]*/.test(nemayandehPassword))
      addLog(messages.invalidPassword, 'error');
    if (!nemyandehOnly && !usePhone && password.length < 8)
      addLog(messages.shortPassword, 'error');
    if (
      !nemyandehOnly &&
      !usePhone &&
      (!password.match(/[a-z]+/g) ||
        !password.match(/[A-Z]+/g) ||
        !password.match(/[0-9]+/g) ||
        !password.match(/[\\~!@#$%^&*]+/g))
    )
      addLog(messages.insecurePassword, 'error');
    if (!testMode && nemayandehPassword.length < 8)
      addLog(messages.shortPassword, 'error');
    if (
      !testMode &&
      (!nemayandehPassword.match(/[a-z]+/g) ||
        !nemayandehPassword.match(/[A-Z]+/g) ||
        !nemayandehPassword.match(/[0-9]+/g) ||
        !nemayandehPassword.match(/[\\~!@#$%^&*]+/g))
    )
      addLog(messages.insecurePassword, 'error');
    if (
      !nemyandehOnly &&
      !/^(https?:\/\/[a-z0-9\\.]+)(:[0-9]+)?$/.test(domain)
    ) {
      addLog(messages.incorrectUrl, 'error');
    }
  };

  const checkAccountExistsAndCreateIfNot = async () => {
    let email = emailName.trim() + '@rastech.ir';
    let userName = 'مدیریت سامانه بیمارستان ' + hospitalName.trim();
    if (usePhone) {
      email = emailName.trim();
      userName = hospitalName.trim();
    }
    async function registerUserInManageServer(accessToken: string) {
      addLog('بررسی کاربر: ', 'header');
      const statusRequest = await apis.getUserStatus(accessToken);
      let status: any = statusRequest.data;
      if (status.userStatus.register === 'Registered') {
        addLog('کاربر وجود دارد', 'info');
        if (status.name !== userName) {
          status.name = userName;
          status = await apis.userUpdate(accessToken, status);
          addLog('کاربر تغییر نام داده شد', 'success');
        }
      } else {
        addLog('کاربر وجود ندارد', 'info');

        status = {
          name: userName,
        };
        status = await apis.registerUser(accessToken, status);
        addLog('کاربر ساخته شد', 'success');
      }
      status.access_token = accessToken;
      return status;
    }

    async function addSupportPermissionToCompanyOwner(userId: number) {
      addLog('دادن دسترسی مدیر سامانه', 'info');
      await apis.editMakhsanRoleForUser(
        userId,
        'Support',
        'add',
        targetAdminToken
      );
      addLog('دسترسی پشتیبانی به مدیر سامانه داده شده', 'success');
    }

    try {
      addLog('بررسی کاربری: ', 'header');

      let result: AxiosResponse<ITwoFactorAuthenticationParams>;

      let accessToken: string;
      let userId: string;
      if (!usePhone) {
        result = await apis.authenticate2FA(null, email, password);
        accessToken = result.data.authInfo.accessToken;
        userId = result.data.authInfo.userId;
      } else {
        result = await apis.authenticate2FA(email, null, null, false, true);
        const code = prompt('enter code');
        const result2 = await apis.enterWithSingleAccessCode(
          result.data.phoneAuth.publicPart + code,
          false
        );
        accessToken = result2.data.accessToken;
        userId = result2.data.userId;
      }
      addLog('کاربری وجود دارد', 'warn');
      await addSupportPermissionToCompanyOwner(Number(userId));
      return await registerUserInManageServer(accessToken);
    } catch (error) {
      addLog('کاربر وجود ندارد', 'info');
      const reCaptchaValue = reCaptcha.current?.getValue();
      const result = await apis.secureRegister(email, password, reCaptchaValue);
      addLog('کاربری ساخته شد', 'success');
      await addSupportPermissionToCompanyOwner(Number(result.data.userId));
      const accessToken = result.data.accessToken;
      return await registerUserInManageServer(accessToken);
    }
  };

  const checkNemayandehAccountExistsAndCreateIfNot = async () => {
    const email = nemayandehEmailName.trim() + '@rastech.ir';
    const userName = 'نماینده بیمارستان ' + hospitalName.trim();

    async function registerUserInManageServer(accessToken: string) {
      addLog('بررسی کاربر نماینده: ', 'header');
      const statusRequest = await apis.getUserStatus(accessToken);
      let status: any = statusRequest.data;
      if (status.userStatus.register === 'Registered') {
        addLog('کاربر وجود دارد', 'info');
        if (status.name !== userName) {
          status.name = userName;
          status = await apis.userUpdate(accessToken, status);
          addLog('کاربر تغییر نام داده شد', 'success');
        }
      } else {
        addLog('کاربر وجود ندارد', 'info');

        status = {
          name: userName,
        };
        status = await apis.registerUser(accessToken, status);
        addLog('کاربر ساخته شد', 'success');
      }
      status.access_token = accessToken;
      return status;
    }

    try {
      addLog('بررسی کاربری نماینده: ', 'header');
      const result = await apis.authenticate2FA(
        null,
        email,
        nemayandehPassword
      );
      addLog('کاربری وجود دارد', 'warn');
      const accessToken = result.data.authInfo.accessToken;
      return await registerUserInManageServer(accessToken);
    } catch (error) {
      addLog('کاربر وجود ندارد', 'info');
      const reCaptchaValue = reCaptcha.current?.getValue();
      const result = await apis.secureRegister(
        email,
        nemayandehPassword,
        reCaptchaValue
      );
      addLog('کاربری ساخته شد', 'success');
      const accessToken = result.data.accessToken;
      return await registerUserInManageServer(accessToken);
    }
  };

  const checkCompanyExistsAndCreateIfNot = async (
    accessToken: string,
    userId: number
  ) => {
    const companyName = getFinalName();
    if (!userId) addLog('invalid UserID', 'error');
    addLog('بررسی شرکت: ', 'header');
    const companyRequest = await apis.getAllCompany(accessToken, false);
    let company: ICompany | undefined = companyRequest.data
      ?.sort((a, b) => a.id - b.id)
      .find((c) => c.owner.userId === userId);
    if (company) {
      addLog('شرکت وجود دارد', 'info');
      if (company.name !== companyName) {
        company.name = companyName;
        company = (await apis.updateCompany(company, accessToken)).data;
        addLog('شرکت تغییر نام داده شد', 'success');
      }
    } else {
      addLog('شرکت وجود ندارد', 'info');

      company = {
        name: companyName,
      } as any;
      company = (await apis.createCompany(company!, accessToken)).data;
      company = (
        await apis.getCompany(
          accessToken,
          company!.id,
          false,
          false,
          false,
          false
        )
      ).data;
      addLog('شرکت ساخته شد', 'success');
    }
    return company;
  };
  const checkProviderExistsAndCreateIfNot = async (
    accessToken: string,
    company: ICompany
  ) => {
    const providerName = getFinalName();

    addLog('بررسی محتوا: ', 'header');
    const providerRequest = await apis.getProviderStatus(accessToken);
    let provider: IProvider = providerRequest.data;
    if (provider.status.register === 'Registered') {
      addLog('محتوا وجود دارد', 'info');
      if (
        provider.name !== providerName ||
        !provider.useVirtualSpaces ||
        provider.managingCompanyId !== company.id ||
        !provider.limitAccessToCompany
      ) {
        provider.name = providerName;
        provider.useVirtualSpaces = true;
        provider.managingCompanyId = company.id;
        provider.limitAccessToCompany = true;
        provider = (await apis.provider_update(provider, accessToken)).data;
        addLog('تنظیمات محتوا به روز شد', 'success');
      }
    } else {
      addLog('محتوا وجود ندارد', 'info');

      provider = {
        name: providerName,
        useVirtualSpaces: true,
        limitAccessToCompany: true,
        allowSeeThroughItems: true,
        managingCompanyId: company.id,
      } as any;
      provider = (await apis.provider_register(provider, accessToken)).data;
      addLog('محتوا ساخته شد', 'success');
    }
    return provider;
  };

  /**
   * returns balin tag objects
   * @param accessToken
   * @param proivder
   */
  const checkProviderTagExistsAndCreateIfNot = async (
    accessToken: string,
    proivder: IProvider
  ) => {
    addLog('بررسی تگ ها: ', 'header');

    // let tagNames = ['بخش‌ها/واحد‌ها'];
    // const tag = (
    //   await apis.tag_getOrCreateTags(accessToken, proivder.id, tagNames, null)
    // ).data[0].id;
    //
    // const balinId = (
    //   await apis.tag_getOrCreateTags(
    //     accessToken,
    //     proivder.id,
    //     ['بخش‌های بالینی'],
    //     tag
    //   )
    // ).data[0].id;
    // const balinTags = (
    //   await apis.tag_getOrCreateTags(
    //     accessToken,
    //     proivder.id,
    //     balinNames,
    //     balinId
    //   )
    // ).data;
    // const paraId = (
    //   await apis.tag_getOrCreateTags(
    //     accessToken,
    //     proivder.id,
    //     ['واحدهای پاراکلینیک'],
    //     tag
    //   )
    // ).data[0].id;
    // await apis.tag_getOrCreateTags(
    //   accessToken,
    //   proivder.id,
    //   paraclinicNames,
    //   paraId
    // );
    //
    // const officeId = (
    //   await apis.tag_getOrCreateTags(
    //     accessToken,
    //     proivder.id,
    //     ['واحدهای اداری پشتیبانی'],
    //     tag
    //   )
    // ).data[0].id;
    // await apis.tag_getOrCreateTags(
    //   accessToken,
    //   proivder.id,
    //   officeNames,
    //   officeId
    // );

    const tagNames = ['شاخص', 'چک‌لیست'];
    await apis.tag_getOrCreateTags(accessToken, proivder.id, tagNames, null);
    addLog('تگ ها ساخته شده', 'success');
    // return bal inTags as ITagView[];
  };
  /**
   *
   */
  const createCompanyRoles = async (accessToken: string, company: ICompany) => {
    addLog('بررسی سمت ها: ', 'header');
    for (const r of projectRoleNames) {
      Object.values(company.roles).find((it) => it.name === r)?.id ||
        (
          await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: false,
              name: r,
              roleType: 'InProject',
              isProjectRole: true,
              projectTags: ['کمیته‌ها'],
              stub: false,
            },
            accessToken
          )
        ).data.updateRoles[0].id;
    }
    const hospital =
      Object.values(company.roles).find((it) => it.name === 'بیمارستان')?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'بیمارستان',
            roleType: 'District',
            relatedTagId: -1,
            stub: false,
          },
          accessToken
        )
      ).data.updateRoles[0].id;
    Object.values(company.roles).find((it) => it.name === 'خارج از بیمارستان')
      ?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'خارج از بیمارستان',
            roleType: 'District',
            relatedTagId: -1,
            stub: false,
          },
          accessToken
        )
      ).data.updateRoles[0].id;

    const balinId =
      Object.values(company.roles).find((it) => it.name === 'بخش‌های بالینی')
        ?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'بخش‌های بالینی',
            roleType: 'District',
            stub: false,
            relatedTagId: -1,
            surroundingMeRoles: [hospital],
          },
          accessToken
        )
      ).data.updateRoles[0].id;
    const paraId =
      Object.values(company.roles).find(
        (it) => it.name === 'بخش‌های پاراکلینیک'
      )?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'بخش‌های پاراکلینیک',
            roleType: 'District',
            stub: false,
            relatedTagId: -1,
            surroundingMeRoles: [hospital],
          },
          accessToken
        )
      ).data.updateRoles[0].id;
    const officeId =
      Object.values(company.roles).find(
        (it) =>
          it.name === 'واحد‌های اداری و پشتیبانی' ||
          it.name === 'واحدهای اداری و پشتیبانی'
      )?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'واحدهای اداری و پشتیبانی',
            roleType: 'District',
            stub: false,
            relatedTagId: -1,
            surroundingMeRoles: [hospital],
          },
          accessToken
        )
      ).data.updateRoles[0].id;
    const clinicId =
      Object.values(company.roles).find((it) => it.name === 'درمانگاه‌ها‌')
        ?.id ||
      (
        await apis.addRole(
          {
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            companyId: company.id,
            description: null,
            id: null,
            isUnique: false,
            name: 'درمانگاه‌ها‌',
            roleType: 'District',
            stub: false,
            relatedTagId: -1,
            surroundingMeRoles: [hospital],
          },
          accessToken
        )
      ).data.updateRoles[0].id;

    async function createInternalRoles(
      combinedUnique: string[],
      combined: string[],
      unique: string[],
      other: string[],
      combineWith: number,
      district: string[]
    ) {
      for (const it of district) {
        Object.values(company.roles).find((i) => i.name === it)?.id ||
          (await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: false,
              name: it,
              roleType: 'District',
              stub: false,
              relatedTagId: -1,
              surroundingMeRoles: [combineWith],
            },
            accessToken
          ));
      }
      for (const it of combinedUnique) {
        Object.values(company.roles).find((i) => i.name === it)?.id ||
          (await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: false,
              name: it,
              roleType: 'Post',
              stub: false,
              surroundingMeRoles: [],
              compoundCreationWithRoleId: combineWith,
              compoundCreationIsUnique: true,
            },
            accessToken
          ));
      }

      for (const it of combined) {
        Object.values(company.roles).find((i) => i.name === it)?.id ||
          (await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: false,
              name: it,
              roleType: 'Post',
              stub: false,
              surroundingMeRoles: [],
              compoundCreationWithRoleId: combineWith,
              compoundCreationIsUnique: false,
            },
            accessToken
          ));
      }
      for (const it of unique) {
        Object.values(company.roles).find((i) => i.name === it)?.id ||
          (await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: true,
              name: it,
              roleType: 'Post',
              stub: false,
              surroundingMeRoles: [],
            },
            accessToken
          ));
      }
      for (const it of other) {
        Object.values(company.roles).find((i) => i.name === it)?.id ||
          (await apis.addRole(
            {
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              companyId: company.id,
              description: null,
              id: null,
              isUnique: false,
              name: it,
              roleType: 'Post',
              stub: false,
              surroundingMeRoles: [],
            },
            accessToken
          ));
      }
    }

    await createInternalRoles(
      balinRoleNamesCombinedUnique,
      balinRoleNamesCombined,
      balinRoleNamesUnique,
      balinRoleNamesOther,
      balinId,
      balinNames
    );
    await createInternalRoles(
      clinicRoleNamesCombinedUnique,
      clinicRoleNamesCombined,
      clinicRoleNamesUnique,
      clinicRoleNamesOther,
      clinicId,
      clinicNames
    );
    await createInternalRoles(
      paraclinicRoleNamesCombinedUnique,
      paraclinicRoleNamesCombined,
      paraclinicRoleNamesUnique,
      paraclinicRoleNamesOther,
      paraId,
      paraclinicNames
    );
    await createInternalRoles(
      officeRoleNamesCombinedUnique,
      officeRoleNamesCombined,
      officeRoleNamesUnique,
      officeRoleNamesOther,
      officeId,
      officeNames
    );

    addLog('سمت ها ساخته شد', 'success');
  };
  async function addNemayandehMemberToCompany(nemayandeh: IUser) {
    const adminCompany = (
      await apis.getCompany(
        mainServerToken!,
        adminCompanyId,
        true,
        false,
        true,
        true
      )
    ).data;
    if (
      Object.values(adminCompany.members).find(
        (it) => it.userId === nemayandeh.id
      )
    )
      addLog('نمایده عضو شرکت است ', 'info');
    else {
      await apis.addCompanyMember(
        {
          conversationInboxId: 0,
          inactive: false,
          roles: {},
          signature: null,
          userId: nemayandeh.id,
          admin: false,
          companyId: adminCompanyId,
        },
        mainServerToken
      );
      addLog('نمایده عضو شرکت شد ', 'success');
    }
    let role = Object.values(adminCompany.roles).find(
      (it) => it.name === nemayandeh.name
    );
    if (role) {
      addLog('سمت نمایده وجود دارد', 'info');
    } else {
      role = (
        await apis.addRole(
          {
            companyId: adminCompanyId,
            description: '',
            id: null,
            name: nemayandeh.name,
            stub: false,
            roleType: 'Post',
            allowManualAssignToMember: true,
            applyIfAllSurroundingExists: false,
            isUnique: false,
          },
          mainServerToken
        )
      ).data.updateRoles[0];
      addLog('سمت ساخته شد', 'success');
    }
    if (role?.users?.find((it) => it.userId === nemayandeh.id))
      addLog('سمت به نماینده تخصیص داده شده است', 'info');
    else {
      await apis.addRoles(
        [
          {
            roleId: role!.id as number,
            userId: nemayandeh.id,
          },
          {
            roleId: 2532, // بیمارستانهای فعال پشتیبانی
            userId: nemayandeh.id,
          },
        ],
        mainServerToken
      );
      addLog('سمت به نماینده تخصیص داده شد', 'success');
    }
    return role;
  }

  const kpiForms = [
    {
      surveyToken:
        'i3SpkjQ7i8xvPzWYhYYPXwCSyv4rvUVw/EXfDgkyfmNz/r1+K1AEp/GPEg72GyICza3RULdRyV/oYFP+WZORQIWhOvDi7oYoxk7Va7JCE7A=',
      questionId: 281154615617351,
    },
    {
      surveyToken:
        'dYmhOtFz5DTaALPba79afQCSyv4rvUVw/EXfDgkyfmNz/r1+K1AEp/GPEg72GyICza3RULdRyV/oYFP+WZORQIWhOvDi7oYoxk7Va7JCE7A=',
      questionId: 707050608039477,
    },
    {
      surveyToken:
        'SO/OKQAkcLgrhGh3KWxoXwCSyv4rvUVw/EXfDgkyfmNz/r1+K1AEp/GPEg72GyICza3RULdRyV/oYFP+WZORQIWhOvDi7oYoxk7Va7JCE7A=',
      questionId: 721658106211220,
    },
    {
      surveyToken:
        'oQMpeIB7D5pLldQsaSFukgCSyv4rvUVw/EXfDgkyfmNz/r1+K1AEp/GPEg72GyICza3RULdRyV/oYFP+WZORQIWhOvDi7oYoxk7Va7JCE7A=',
      questionId: 281154615617351,
    },
  ];
  async function updateKpiConfigsInMainServer() {
    const finalName = getFinalName();
    addLog('بررسی پرسنامه kpi', 'header');
    for (const item of kpiForms) {
      const survey = (await apis.getSurvey(item.surveyToken)).data;
      const mc = survey.surveyQuestionList.find(
        (it) => it.id === item.questionId
      ) as IMultipleChoiceQuestionView;
      if (!mc.choiceList.find((it) => it.text === finalName)) {
        mc.choiceList.push({
          text: finalName,
          value: finalName.replaceAll(/\s/g, '_'),
          score: null,
        });
        apis.surveyUpdateQuestion(mc, item.surveyToken, mainServerToken!);
        addLog('بیمارستان به پرسشنامه kpi اضافه شد', 'success');
      } else {
        addLog('بیمارستان در پرسشنامه kpi وجود دارد', 'info');
      }
    }
  }

  async function setKPISource(company: ICompany) {
    const accessTokenToUse = targetAdminToken || mainServerToken;
    const currentConfig = (
      await apis.getConfig('companyJson', accessTokenToUse!)
    ).data;
    const currentConfigArray: { [key: string]: string } =
      JSON.parse(currentConfig.value) || {};
    currentConfigArray[company.id.toString()] = company.name;
    currentConfig.value = JSON.stringify(currentConfigArray);
    await apis.updateConfig(currentConfig, accessTokenToUse!);
    addLog('لیست بیمارستان مشمول در سرور به روز شده', 'success');
  }

  async function copyTemplates(company: ICompany, access_token: string) {
    addLog('در حال ساخت تمپلیت ها', 'info');

    const idMap = new Map<number, ICompanyTemplate>();
    for (let i = 0; i < Object.values(baseCompany!.templates).length; i++) {
      const toCopyTemplate = baseCompany!.templates[i];
      let template = Object.values(company.templates)?.find(
        (it) => it.task?.taskName === toCopyTemplate.task?.taskName
      );
      if (!template) {
        template = cloneDeep(
          Object.values(baseCompany!.templates)?.find(
            (it) => it.taskId === toCopyTemplate.taskId
          )
        ) as ICompanyTemplate;
        template.companyId = company.id;
        template.children = [];
        const currentId = template.taskId;
        template.taskId = undefined as any;
        template.task!.id = undefined as any;
        template.task!['verifier'] = null;
        template.task!.verifiers = [];
        template.task!.taskPublisher = null;
        template.task!.subTaskPublisher = null;
        idMap.set(
          currentId,
          (await apis.addCompanyTemplate(template, access_token)).data
        );
        addLog(`تمپلیت ${template.task?.taskName} ایجاد شد`, 'success');
      } else {
        idMap.set(toCopyTemplate.taskId, template);
        addLog(
          `تمپلیت ${template.task?.taskName} یافت شد و به روز نخواهد شد `,
          'success'
        );
      }
    }
    for (let i = 0; i < Object.values(baseCompany!.templates).length; i++) {
      const toCopyTemplate = baseCompany!.templates[i];
      const refTemplate = Object.values(baseCompany!.templates).find(
        (it) => it.taskId === toCopyTemplate.taskId
      )!;
      const template = idMap.get(toCopyTemplate.taskId)!;
      template.children = refTemplate.children?.map(
        (it) => idMap.get(it)!.taskId
      );
      (await apis.updateCompanyTemplate(template, access_token)).data;
      addLog(
        `ساختار درختی تمپلیت ${template.task?.taskName} درست شد   `,
        'success'
      );
    }
  }
  // @ts-expect-error temporarily keeping this function
  async function copyStTemplates(
    company: ICompany,
    access_token: string,
    adminCompany: ICompany
  ) {
    addLog('در حال ساخت تمپلیت برنامه استقرار', 'info');
    const templateIds = [programTemplateId, stepTemplateId];

    const idMap = new Map<number, ICompanyTemplate>();
    for (let i = 0; i < templateIds.length; i++) {
      const toCopyTemplate = Object.values(adminCompany!.templates).find(
        (it) => {
          return it.taskId === templateIds[i];
        }
      );
      let template = Object.values(company.templates)?.find(
        (it) => it.task?.taskName === toCopyTemplate!.task?.taskName
      );
      if (!template) {
        template = cloneDeep(toCopyTemplate) as ICompanyTemplate;
        template.companyId = company.id;
        template.children = [];
        const currentId = template.taskId;
        template.taskId = undefined as any;
        template.task!.id = undefined as any;
        idMap.set(
          currentId,
          (await apis.addCompanyTemplate(template, access_token)).data
        );
        addLog(`تمپلیت ${template.task?.taskName} ایجاد شد`, 'success');
      } else {
        idMap.set(Number(templateIds[i]), template);
        addLog(
          `تمپلیت ${template.task?.taskName} یافت شد و به روز نخواهد شد `,
          'success'
        );
      }
    }
    for (let i = 0; i < templateIds.length; i++) {
      const toCopyTemplate = templateIds[i];
      const refTemplate = Object.values(adminCompany!.templates).find(
        (it) => it.taskId === toCopyTemplate
      )!;
      const template = idMap[Number(toCopyTemplate)]!;
      template.children = refTemplate.children?.map((it) => idMap[it]!.taskId);
      (await apis.updateCompanyTemplate(template, access_token)).data;
      addLog(
        `ساختار درختی تمپلیت ${template.task?.taskName} درست شد   `,
        'success'
      );
    }
    return idMap;
  }

  async function addInitRoles(company: ICompany, access_token: string) {
    const roles = [SupportRole, CompanyAdvanceAdminRole];
    const createdSupportRole = [];
    for (const roleName of roles) {
      let currentRole = Object.values(company.roles).find(
        (it) =>
          it.name.replaceAll('\\s+', '') === roleName.replaceAll('\\s+', '')
      );
      if (!currentRole) {
        currentRole = (
          await apis.addRole(
            {
              companyId: company.id,
              description: '',
              id: null,
              name: roleName,
              stub: false,
              roleType: 'Post',
              allowManualAssignToMember: true,
              applyIfAllSurroundingExists: false,
              isUnique: false,
            },
            access_token
          )
        ).data.updateRoles[0];
        addLog(`سمت ${roleName} ساخت شد `, 'success');
      } else {
        addLog(`سمت ${roleName} وجود دارد `, 'success');
      }
      if (currentRole?.name === SupportRole)
        createdSupportRole.push(currentRole);
    }
    return createdSupportRole;
  }

  async function copySampleHospitalAsPanel(
    access_token: string,
    provider: IProvider
  ) {
    const sourceItemId = 134948;
    const currentItems = (
      await apis.provider_getDocumentsInFolder(
        provider.rootDocument!.id,
        access_token
      )
    ).data;
    if (!currentItems.find((it) => it.name === 'پشتیبانی هاسپیتک')) {
      addLog('در حال کپی بیمارستان نمونه', 'success');
      apis.provider_importContentFromRemote(
        sourceItemId,
        provider.rootDocument!.id,
        mainServerUrl + '/man/',
        mainServerToken!,
        true,
        true,
        access_token
      );
      addLog('بیمارستان نمونه در بیمارستان ساخته شده', 'success');
    } else {
      addLog('بیمارستان نمونه در بیمارستان وجود دارد', 'info');
    }
  }

  // async function copyHospitalSpecificPanelInRastechServer(
  //   role: ICompanyRoleServer
  // ) {
  //   addLog('بررسی اسناد اختصاصی بیمارستان', 'header');
  //   const sourceItemId = 86684;
  //   const targetItemId = 86673;
  //   const hospitalName = getFinalName();
  //   const toUseAccesstoken = mainServerToken;
  //   const currentItems = (
  //     await apis.provider_getDocumentsInFolder(
  //       targetItemId,
  //       toUseAccesstoken!,
  //       0,
  //       1000
  //     )
  //   ).data;
  //   const currentIds = currentItems.map((it) => it.id);
  //   let hospitalFolder = currentItems.find((it) => it.name === hospitalName);
  //   if (!hospitalFolder) {
  //     await apis.provider_importContentFromRemote(
  //       sourceItemId,
  //       targetItemId,
  //       mainServerUrl + '/man/',
  //       toUseAccesstoken!,
  //       true,
  //       false,
  //       toUseAccesstoken!
  //     );
  //     const newCurrentItems = (
  //       await apis.provider_getDocumentsInFolder(
  //         targetItemId,
  //         toUseAccesstoken!,
  //         0,
  //         1000
  //       )
  //     ).data;
  //     hospitalFolder = newCurrentItems.find(
  //       (it) => !currentIds.includes(it.id)
  //     );
  //     hospitalFolder!.name = hospitalName;
  //     await apis.updateFolder(hospitalFolder!, toUseAccesstoken!);
  //     addLog('اسناد اختصاصی بیمارستان ساخته شده', 'success');
  //   } else {
  //     addLog('اسناد اختصاصی بیمارستان وجود دارد', 'info');
  //   }
  //   const limitationId = (
  //     await apis.createReadLimitation(hospitalFolder!.id, toUseAccesstoken!)
  //   ).data.readLimitationId;
  //   const limitation = (
  //     await apis.getLimitation(limitationId!, toUseAccesstoken!)
  //   ).data;
  //   if (!limitation.exceptedRoles.find((it) => it.id === role.id!)) {
  //     await apis.permissionAddRole(limitation.id, role.id!, toUseAccesstoken!);
  //     addLog('دسترسی روی اسناد اختصاصی بیمارستان ست شد', 'success');
  //   } else {
  //     addLog('دسترسی روی اسناد اختصاصی بیمارستان وجود دارد', 'info');
  //   }
  // }

  async function addTagAndPermissionScheme(role: ICompanyRoleServer) {
    const parentTagId = 18829; // بیمارستانهای فعال پشتیبانی
    const tag = (
      await apis.tag_getOrCreateTags(
        mainServerToken!,
        adminProviderId,
        [hospitalName.trim()],
        parentTagId
      )
    ).data[0];
    const adminCompany = (
      await apis.getCompany(
        mainServerToken!,
        adminCompanyId,
        true,
        false,
        true,
        true
      )
    ).data;
    const permissionScheme = Object.values(
      adminCompany.permissionSchemes
    )?.find((it) => it.id === 1);
    permissionScheme!.properties.roleIdTagIdListMap[role.id!] = [tag.id];
    apis.updatePermissionScheme(permissionScheme!, mainServerToken!);
    addLog('طرح دسترسی ایجاد / به روز شد', 'success');
  }

  async function addOrUpdateTaskInTargetServer(
    newTask: ITask,
    found: ITask | undefined,
    access_token: string,
    oldtoNewTemplateIdMap: Map<number, ICompanyTemplate>,
    targetProject: IProject | IProjectStore,
    userIdMap: { [key: number]: number },
    supportRole: ICompanyRole
  ) {
    if (found && onlyAddTask) return Promise.resolve(found);
    if (!newTask.fields) newTask.fields = [];
    newTask.fields.push({
      type: 'text',
      name: 'OID',
      title: 'شناسه مرجع',
      value: newTask.id.toString(),
      options: null,
    });
    newTask.projectId = targetProject.id;

    function fill(it?: IAssignmentView) {
      if (!it) return it;
      if (!it.properties) it.properties = {} as any;
      it.userId = userIdMap[it.userId];
      it.properties!.roleId = supportRole.id;
      it.properties!.roleName = supportRole.name;
      it.taskId = undefined;
      return it;
    }

    newTask.assignee =
      Object.values(newTask?.assignee)?.map((it) => {
        return fill(it)!;
      }) || [];
    newTask.followers =
      Object.values(newTask?.followers)?.map((it) => {
        it.userId = userIdMap[it.userId];
        it.taskId = undefined;
        return it;
      }) || [];
    // newTask.verifier = fill(cloneDeep(newTask?.verifier) || undefined) || null;
    newTask.taskPublisher =
      fill(cloneDeep(newTask?.taskPublisher) || undefined) || null;
    newTask.subTaskPublisher =
      fill(cloneDeep(newTask?.subTaskPublisher) || undefined) || null;
    newTask.creator = found?.creator || (null as any);
    newTask.templateId = oldtoNewTemplateIdMap[newTask.templateId]!.taskId;
    if (found) {
      newTask.id = found.id;
      const ret = (await apis.updateTask(newTask, access_token)).data;
      addLog(`«${newTask.title}» به روز شد`, 'success');
      return ret;
    } else {
      newTask.id = undefined as any;
      const ret = (await apis.createTask(newTask, access_token)).data;
      addLog(`«${newTask.title}» کپی شد`, 'success');
      return ret;
    }
  }

  // @ts-expect-error temporarily keeping this function
  async function copySetupTasks(
    oldToNewTemplateIdMap: Map<number, ICompanyTemplate>,
    company: ICompany,
    access_token: string,
    userId: number,
    userIdMap: { [key: number]: number },
    supportRole: ICompanyRole
  ) {
    const newProgramTemplateId =
      oldToNewTemplateIdMap[programTemplateId]!.taskId;
    // const newStepTemplateId = oldToNewTemplateIdMap[stepTemplateId];
    let targetProject: IProject | IProjectStore | undefined = Object.values(
      company.projects
    ).find((it) => it.name === setupProjectName);
    if (!targetProject) {
      targetProject = (
        await apis.createProject(
          {
            name: setupProjectName,
            companyId: company.id,
            templates: [],
            id: undefined as any,
            tags: [],
            description: '',
            visibleAllTasks: true,
            archived: false,
          },
          access_token
        )
      ).data;
      addLog('پروژه استقرار ایجاد شد', 'success');
    } else addLog('پروژه استقرار وجود دارد', 'info');

    if (
      !targetProject.templates?.find((it) => it.taskId === newProgramTemplateId)
    ) {
      await apis.addTemplateToProject(
        {
          taskId: newProgramTemplateId,
          allowRoot: true,
          projectId: targetProject.id,
        } as any,
        access_token
      );
      addLog(
        `قالب استقرار در پروژه «${targetProject.name}» ایجاد شد`,
        'success'
      );
    }
    for (const userId1 of [userId, ...Object.values(userIdMap)]) {
      try {
        await apis.addProjectMember(
          {
            projectId: targetProject!.id,
            admin: true,
            userId: userId1,
            implicit: false,
          } as any,
          access_token
        );
        addLog(`عضویت در پروژه «${targetProject!.name}» ایجاد شد`, 'success');
      } catch (e) {
        /*do nothing*/
      }
    }

    setBaseUrl(mainServerUrl);
    const allBaseTasks = (
      await apis.searchTasks(
        {
          projectId: setupProjectId,
          archived: false,
          includeDrafted: false,
          from: 0,
          count: 200,
          parentId: -1,
        },
        mainServerToken!
      )
    ).data;
    setBaseUrl(domain);
    const allTargetTasks = (
      await apis.searchTasks(
        {
          projectId: targetProject!.id,
          archived: false,
          includeDrafted: false,
          from: 0,
          count: 200,
          parentId: -1,
        },
        access_token
      )
    ).data;
    const rootTaskMap: { [key: number]: number } = {};
    for (const it of allBaseTasks.filter((it) => !it.parentId)) {
      const found = allTargetTasks.find((t) => {
        return t.fields.find(
          (f) => f.name === 'OID' && f.value === it.id.toString()
        );
      });
      let newTask = cloneDeep(it);
      newTask.parentId = undefined as any;
      newTask = await addOrUpdateTaskInTargetServer(
        newTask,
        found,
        access_token,
        oldToNewTemplateIdMap,
        targetProject,
        userIdMap,
        supportRole
      );
      rootTaskMap[it.id] = newTask.id;
    }

    for (const it of allBaseTasks.filter((it) => it.parentId)) {
      const found = allTargetTasks.find((t) => {
        return t.fields.find(
          (f) => f.name === 'OID' && f.value === it.id.toString()
        );
      });
      const newTask = cloneDeep(it);
      newTask.parentId = rootTaskMap[it.parentId];
      if (!newTask.parentId) continue;
      await addOrUpdateTaskInTargetServer(
        newTask,
        found,
        access_token,
        oldToNewTemplateIdMap,
        targetProject,
        userIdMap,
        supportRole
      );
    }
  }

  // @ts-expect-error temporarily keeping this function
  async function copySupportMembers(
    adminCompany: ICompany,
    targetComany: ICompany,
    token: string
  ) {
    const userNameIdMap: { [key: string]: number } = {};
    const userIds = new Set<number>();
    const userIdMap: { [key: number]: number } = {};
    Object.values(
      adminCompany.projects[setupProjectId].projectMembers || {}
    )?.forEach((member) => {
      if (member.userId !== null) userIds.add(member.userId!);
    });
    Object.values(adminCompany.roles)
      .find((it) => it.name === 'تیم پشتیبانی')
      ?.users?.forEach((it) => {
        userIds.add(it.userId!);
      });
    setBaseUrl(mainServerUrl);
    const toInviteMembers: IInvitedMember[] = [];
    for (const it of (
      await apis.user_getAll(Array.from(userIds), mainServerToken!)
    ).data) {
      userNameIdMap[it.name] = it.id;
      toInviteMembers.push({
        name: it.name,
        inactive: false,
        roles: ['پشتیبان رستک'],
        phoneNumber: it.phoneNumber!,
        employeeId: '',
      });
    }
    setBaseUrl(domain);
    (
      await apis.companyAddMembers(
        toInviteMembers,
        true,
        targetComany.id,
        token
      )
    ).data.forEach((newU) => {
      const oldUserId = userNameIdMap[newU.name];
      userIdMap[oldUserId] = newU.id;
    });
    addLog('تیم پشتیبانی رستک دعوت شد', 'success');
    return userIdMap;
  }

  const checkAndSetAll = async () => {
    try {
      setDisabled(true);
      verifyInput();
      if (!testMode) {
        setBaseUrl(mainServerUrl);
        const nemayandeh = await checkNemayandehAccountExistsAndCreateIfNot();
        const role = await addNemayandehMemberToCompany(nemayandeh);
        await addTagAndPermissionScheme(role as any);
        await updateKpiConfigsInMainServer();
        // await copyHospitalSpecificPanelInRastechServer(role as any);
      }

      if (nemyandehOnly) {
        setDisabled(false);
        return;
      }

      setBaseUrl(domain);
      const userInfo = await checkAccountExistsAndCreateIfNot();
      const company = await checkCompanyExistsAndCreateIfNot(
        userInfo.access_token,
        userInfo.id
      );
      const provider = await checkProviderExistsAndCreateIfNot(
        userInfo.access_token,
        company
      );
      await createCompanyRoles(userInfo.access_token, company);
      await checkProviderTagExistsAndCreateIfNot(
        userInfo.access_token,
        provider
      );
      // await createPermissionScheme(
      //   balinTags,
      //   'سرپرستار ',
      //   'سرپرستار بخش مربوطه',
      //   company,
      //   userInfo.access_token
      // );
      /*const [supportRole] =*/ await addInitRoles(
        company,
        userInfo.access_token
      );
      setBaseUrl(mainServerUrl);
      // const adminCompany = (
      //   await apis.getCompany(
      //     mainServerToken,
      //     adminCompanyId,
      //     false,
      //     false,
      //     false,
      //     true
      //   )
      // ).data;
      setBaseUrl(domain);
      if (!skipCopyTemplate) {
        await copyTemplates(company, userInfo.access_token);
      }
      // const oldtoNewTemplateIdMap = await copyStTemplates(
      //   companyObject,
      //   userInfo.access_token,
      //   adminCompany
      // );
      // const userIdMap = await copySupportMembers(
      //   adminCompany,
      //   companyObject,
      //   userInfo.access_token
      // );
      // await copySetupTasks(
      //   oldtoNewTemplateIdMap,
      //   companyObject,
      //   userInfo.access_token,
      //   userInfo.id,
      //   userIdMap,
      //   supportRole
      // );
      if (!testMode) {
        await setKPISource(company);
      }
      await copySampleHospitalAsPanel(userInfo.access_token, provider);
    } catch (e) {
      setDisabled(false);
      addLog('خطا در فرایند ساخت', 'error');
      addLog((e as any).toString(), 'error');
    }
    setDisabled(false);
  };
  return (
    <div style={{ height: '100%', padding: '20px' }}>
      <div className="row">
        <div className="col s12 m6 l6">
          <h6>{messages.hospitalInfo}</h6>
          <Input
            id="name"
            type="text"
            value={hospitalName}
            disabled={disabled}
            label={messages.hospitalName}
            placeholder={messages.nameSample}
            onChange={(e) => setHospitalName(e.target.value)}
          />
          <Input
            id="emailName"
            type="text"
            value={emailName}
            disabled={disabled}
            label={messages.hospitalEmailName}
            placeholder={messages.emailNameSample}
            onChange={(e) => setEmailName(e.target.value)}
          />
          <Input
            id="password"
            type="text"
            value={password}
            disabled={disabled}
            label={messages.password}
            placeholder={messages.passwordSample}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            id="domain"
            type="text"
            value={domain}
            label={messages.domainWithProtocol}
            disabled={disabled}
            placeholder={messages.domainSample}
            onChange={(e) => setDomain(e.target.value)}
          />
          <Input
            id="targetServeradminToken"
            type="text"
            value={targetAdminToken}
            label={messages.targetAdminToken}
            disabled={disabled}
            onChange={(e) => setTargetAdminToken(e.target.value)}
          />
          <AnyRecaptcha
            ref={reCaptcha}
            sitekey="6LdhgEMUAAAAANlZOvlLciJOXTjIds8PF5OkVpzu"
            style={{
              margin: '0.4rem 0',
              display: 'flex',
              justifyContent: 'center',
            }}
          />
        </div>
        <div className="col s12 m6 l6">
          <h6>{messages.nemayandeh}</h6>
          <Input
            id="testMode"
            type="checkbox"
            checked={testMode}
            onChange={(e) => {
              setTestMode(e.target.checked);
              if (e.target.checked) {
                setEmailName('copy.setup');
                setHospitalName('تست کپی برنامه');
                setTargetAdminToken(
                  'P5pxXNPTdsFf5iRCBvPcjlLv5WFzrJL0M+DrhPL82LVO4o98c3V7OqUlkhWKxAehV72QO8Uur7J0CoYexE1SRHAW29g9TFf+s658HCY3sE3MnOljOzDlUxnl+Hcl2Fjvo6BpT0W9NOs3odKqKgZmIpR6evUjIxiRGWvtBkpmGB/ez7fdMl+3wc11ihGipv7LVMJU8KYwxhNMWhAACxpE77RfHJxktXS4jRlcfQEs4XxcDKEZ7mCzjNRsDI2pZ/2fR2N9y90XnV6nJDMhs/Pcbis6oQEKm46yj8CaqMaaMeCqUHIT+bpDixMQL/2C+e0D3p9DwNbJthzD66foZynbxa58ZvxvWJqMGKYpHz/PObFFm+mE0pIE1LAM8ElZG8HzvejgpUvC1fOdGEcEJo/q1k3IeHIfnGPQzzY/i1zhq69RQygyXDrHbfDp9qo3Lez7CizJ6aTi3eW53xm+r/DSsvNc/PMcL+5pL3/02/sIuhMy6A3NKW+C42kv//Bvk1OJpPTNQEPz8HSyJRuGOsFqRwziSXVaew3H6A8WfJGRKEclmYSimZi6AvTOjilldqaDqIn1QCl8c/kZcIxYnU3O0qaCaMSo7y23h0FWznUScqSyqOy02bDol9i7bKmshBhrzmUQCcpvQ2f/ONrr9kAXyQvgMUit5BAAmbfqUdDAvRqvl/QeNfJtzcc5XfSx1TPu7zyUaC/fvxqzyBlz7hmn3X17sJtPkfdwzqbx+ihQQpyQMS0aeDHdjqs28UALxlHFuB9rF4JUkyazn2FreFCgQnA4a4vw8UEjjwHnUHgCxVQ='
                );
                setBalinNames([]);
                setBalinRoleNamesUnique([]);
                setBalinRoleNamesCombinedUnique(['سرپرستار']);
                setBalinRoleNamesCombined(['پرستار']);
                setBalinRoleNamesOther(['بهیار']);
                setParaclinicNames([]);
                setParaclinicRoleNamesCombinedUnique(['مسئول بخش']);
                setClinicRoleNamesCombinedUnique(['مسئول']);
                setOfficeNames([]);
                setOfficeRoleNamesCombinedUnique(['مسئول واحد']);
                setClinicNames([]);
                // setToCopyTemplates(templates);
                setDomain('https://app.rastech.ir');
                setPassword('saHo@1234');
              }
            }}
            label={messages.testMode}
          />
          <Input
            id="onlyAdd"
            type="checkbox"
            checked={onlyAddTask}
            onChange={(e) => {
              setOnlyAddTask(e.target.checked);
            }}
            label={messages.onlyAddTask}
          />
          <Input
            id="skipCopyTemplate"
            type="checkbox"
            checked={skipCopyTemplate}
            onChange={(e) => {
              setSkipCopyTemplate(e.target.checked);
            }}
            label={messages.skipCopyTemplate}
          />
          <Input
            id="nemyandehOnly"
            type="checkbox"
            checked={nemyandehOnly}
            onChange={(e) => {
              setNemyandehOnly(e.target.checked);
            }}
            label={messages.nemyandehOnly}
          />
          <Input
            id="emailName"
            type="text"
            value={nemayandehEmailName}
            disabled={disabled}
            label={messages.nemayandehEmailName}
            placeholder={messages.nemayandehMailNameSample}
            onChange={(e) => setNemayandehEmailName(e.target.value)}
          />
          <Input
            id="password"
            type="text"
            value={nemayandehPassword}
            disabled={disabled}
            label={messages.nemayandePassword}
            placeholder={messages.passwordSample}
            onChange={(e) => setNemayandehPassword(e.target.value)}
          />
        </div>
        <h6>{messages.districst}</h6>
        <Collapsible header={'بالین'}>
          <Select
            values={balinNames.map((it) => ({ value: it, label: it }))}
            options={[]}
            letAddChip={true}
            placeholder={messages.balin}
            multiChoice={true}
            label={messages.balin}
            onChangeValues={(values) => {
              setBalinNames(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={balinRoleNamesUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesUnique}
            onChangeValues={(values) => {
              setBalinRoleNamesUnique(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={balinRoleNamesCombinedUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombinedUnique}
            onChangeValues={(values) => {
              setBalinRoleNamesCombinedUnique(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={balinRoleNamesCombined.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombined}
            onChangeValues={(values) => {
              setBalinRoleNamesCombined(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={balinRoleNamesOther.map((it) => ({ value: it, label: it }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesOther}
            onChangeValues={(values) => {
              setBalinRoleNamesOther(values.map((it) => it.value.toString()));
            }}
          />
        </Collapsible>
        <Collapsible header={'پاراکلینیک'}>
          <Select
            values={paraclinicNames.map((it) => ({ value: it, label: it }))}
            options={[]}
            letAddChip={true}
            placeholder={messages.paraclinic}
            multiChoice={true}
            label={messages.paraclinic}
            onChangeValues={(values) => {
              setParaclinicNames(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={paraclinicRoleNamesUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesUnique}
            onChangeValues={(values) => {
              setParaclinicRoleNamesUnique(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={paraclinicRoleNamesCombinedUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombinedUnique}
            onChangeValues={(values) => {
              setParaclinicRoleNamesCombinedUnique(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={paraclinicRoleNamesCombined.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombined}
            onChangeValues={(values) => {
              setParaclinicRoleNamesCombined(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={paraclinicRoleNamesOther.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesOther}
            onChangeValues={(values) => {
              setParaclinicRoleNamesOther(
                values.map((it) => it.value.toString())
              );
            }}
          />
        </Collapsible>
        <Collapsible header={'درمانگاه'}>
          <Select
            values={clinicNames.map((it) => ({ value: it, label: it }))}
            options={[]}
            letAddChip={true}
            placeholder={messages.clinic}
            multiChoice={true}
            label={messages.clinic}
            onChangeValues={(values) => {
              setClinicNames(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={clinicRoleNamesUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesUnique}
            onChangeValues={(values) => {
              setClinicRoleNamesUnique(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={clinicRoleNamesCombinedUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombinedUnique}
            onChangeValues={(values) => {
              setClinicRoleNamesCombinedUnique(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={clinicRoleNamesCombined.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombined}
            onChangeValues={(values) => {
              setClinicRoleNamesCombined(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={clinicRoleNamesOther.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesOther}
            onChangeValues={(values) => {
              setClinicRoleNamesOther(values.map((it) => it.value.toString()));
            }}
          />
        </Collapsible>
        <Collapsible header={'اداری پشتیبانی'}>
          <Select
            values={officeNames.map((it) => ({ value: it, label: it }))}
            options={[]}
            letAddChip={true}
            placeholder={messages.office}
            multiChoice={true}
            label={messages.office}
            onChangeValues={(values) => {
              setOfficeNames(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={officeRoleNamesUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesUnique}
            onChangeValues={(values) => {
              setOfficeRoleNamesUnique(values.map((it) => it.value.toString()));
            }}
          />
          <Select
            values={officeRoleNamesCombinedUnique.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombinedUnique}
            onChangeValues={(values) => {
              setOfficeRoleNamesCombinedUnique(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={officeRoleNamesCombined.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesCombined}
            onChangeValues={(values) => {
              setOfficeRoleNamesCombined(
                values.map((it) => it.value.toString())
              );
            }}
          />
          <Select
            values={officeRoleNamesOther.map((it) => ({
              value: it,
              label: it,
            }))}
            options={[]}
            letAddChip={true}
            multiChoice={true}
            label={messages.roleNamesOther}
            onChangeValues={(values) => {
              setOfficeRoleNamesOther(values.map((it) => it.value.toString()));
            }}
          />
        </Collapsible>
      </div>
      <Select
        values={projectRoleNames.map((it) => ({
          value: it,
          label: it,
        }))}
        options={[]}
        letAddChip={true}
        multiChoice={true}
        label={messages.projectRoles}
        onChangeValues={(values) => {
          setProjectRoleNames(values.map((it) => it.value.toString()));
        }}
      />
      <Button loading={disabled} onClick={checkAndSetAll}>
        {messages.checkAndCreate}
      </Button>
      <div id="logs" style={{ height: '50vh', overflow: 'scroll' }}>
        <div dangerouslySetInnerHTML={{ __html: `<ul>${log}</ul>` }} />
      </div>
    </div>
  );
};

// const mapStateToProps: MapStateToProps<IStateToProps, OwnProps, RootState> = (
//   state
// ) => {
//   const thisUser = state.thisUser;
//   return { thisUser, state };
// };
// const mapDispatchToProps: MapDispatchToProps<
//   IDispatchToProps,
//   OwnProps
// > = () => {
//   return {
//     addMember: (member: ICompanyMember) =>
//       appDispatch(
//         addMemberToCompany({ companyMember: member, noAction: true })
//       ),
//     addRole: (role: ICompanyRoleServer) =>
//       appDispatch(addCompanyRole({ role })),
//     addRoles: (userRoles: IUserRoleView[], companyId: number) =>
//       appDispatch(addUserRoles({ userRoles, companyId })),
//   };
// };

export default protectedRoute(NewHospital);
